"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Palette_1 = require("../model/Palette");
class Palettes {
}
exports.default = Palettes;
Palettes.colodore = new Palette_1.default([
    [0, 0, 0, 0xff],
    [0xff, 0xff, 0xff, 0xff],
    [0x81, 0x33, 0x38, 0xff],
    [0x75, 0xce, 0xc8, 0xff],
    [0x8e, 0x3c, 0x97, 0xff],
    [0x56, 0xac, 0x4d, 0xff],
    [0x2e, 0x2c, 0x9b, 0xff],
    [0xed, 0xf0, 0x71, 0xff],
    [0x8e, 0x50, 0x29, 0xff],
    [0x55, 0x38, 0x00, 0xff],
    [0xc4, 0x6c, 0x71, 0xff],
    [0x4a, 0x4a, 0x4a, 0xff],
    [0x7b, 0x7b, 0x7b, 0xff],
    [0xa9, 0xff, 0x9f, 0xff],
    [0x70, 0x6e, 0xeb, 0xff],
    [0xb2, 0xb2, 0xb2, 0xff]
]);
Palettes.pepto = new Palette_1.default([
    [0, 0, 0, 0xff],
    [0xff, 0xff, 0xff, 0xff],
    [0x68, 0x37, 0x2b, 0xff],
    [0x70, 0xa4, 0xb2, 0xff],
    [0x6f, 0x3d, 0x86, 0xff],
    [0x58, 0x8d, 0x43, 0xff],
    [0x35, 0x28, 0x79, 0xff],
    [0xb8, 0xc7, 0x6f, 0xff],
    [0x6f, 0x4f, 0x25, 0xff],
    [0x43, 0x39, 0x00, 0xff],
    [0x9a, 0x67, 0x59, 0xff],
    [0x44, 0x44, 0x44, 0xff],
    [0x6c, 0x6c, 0x6c, 0xff],
    [0x9a, 0xd2, 0x84, 0xff],
    [0x6c, 0x5e, 0xb5, 0xff],
    [0x95, 0x95, 0x95, 0xff]
]);
Palettes.deekay = new Palette_1.default([
    [0, 0, 0, 0xff],
    [0xff, 0xff, 0xff, 0xff],
    [0x88, 0x20, 0x00, 0xff],
    [0x68, 0xd0, 0xa8, 0xff],
    [0xa8, 0x38, 0xa0, 0xff],
    [0x50, 0xb8, 0x43, 0xff],
    [0x18, 0x10, 0x90, 0xff],
    [0xf0, 0xe8, 0x58, 0xff],
    [0xa0, 0x48, 0x00, 0xff],
    [0x47, 0x2b, 0x1b, 0xff],
    [0xc8, 0x78, 0x70, 0xff],
    [0x48, 0x48, 0x48, 0xff],
    [0x80, 0x80, 0x80, 0xff],
    [0x98, 0xff, 0x98, 0xff],
    [0x50, 0x90, 0xd0, 0xff],
    [0xb8, 0xb8, 0xb8, 0xff]
]);
Palettes.PALette = new Palette_1.default([
    [0, 0, 0, 0xff],
    [0xff, 0xff, 0xff, 0xff],
    [0x8c, 0x32, 0x3d, 0xff],
    [0x66, 0xbf, 0xb3, 0xff],
    [0x8e, 0x36, 0xa1, 0xff],
    [0x4a, 0xa6, 0x48, 0xff],
    [0x32, 0x2d, 0xab, 0xff],
    [0xcd, 0xd2, 0x56, 0xff],
    [0x8f, 0x50, 0x1a, 0xff],
    [0x53, 0x3d, 0x01, 0xff],
    [0xbd, 0x63, 0x6e, 0xff],
    [0x4e, 0x4e, 0x4e, 0xff],
    [0x76, 0x76, 0x76, 0xff],
    [0x8c, 0xe9, 0x8b, 0xff],
    [0x6b, 0x66, 0xe4, 0xff],
    [0xa3, 0xa3, 0xa3, 0xff]
]);
Palettes.all = {
    pepto: Palettes.pepto,
    colodore: Palettes.colodore,
    deekay: Palettes.deekay,
    PALette: Palettes.PALette
};
//# sourceMappingURL=Palettes.js.map